import { createRouter, createWebHistory } from "vue-router";
//import Dashboard from "../views/Dashboard.vue";
import Billing from "../views/Billing.vue";
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/panel",
  },
  {
    path: "/panel",
    name: "Panel",
    component: () => import('@/views/Dashboard.vue'),
  },
  {
    path: "/kary",
    name: "Lista kar",
    component: () => import('@/views/Kary.vue'),
  },
  {
    path: "/login",
    name: "Logowanie",
    component: () => import('@/views/Login.vue'),
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/profil",
    name: "Profil użytkownika",
    component: () => import('@/views/Profil.vue'),
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: () => import('@/views/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
